import axios from 'axios';

export const resolveUrl = (url: string, base?: string) => {
  const fullUrl = new URL(url, base || `${window.location.protocol}//${window.location.host}/api/`);
  return fullUrl.href;
};

export const resolveAIUrl = (url: string, base?: string) => {
  const fullUrl = new URL(url, base || `${window.location.protocol}//${window.location.host}/ai/`);
  return fullUrl.href;
};

export const resolvePreAIUrl = (url: string, base?: string) => {
  const fullUrl = new URL(url, base || `${window.location.protocol}//${window.location.host}/preAi/`);
  return fullUrl.href;
};

export const resolveLightRagUrl = (url: string, base?: string) => {
  const fullUrl = new URL(url, base || `${window.location.protocol}//${window.location.host}/lightrag/`);
  return fullUrl.href;
};

export const getItem = (key: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    const value = localStorage.getItem(key);
    if (value) {
      resolve(value);
    }
    reject(new Error('not exit'));
  });
};

export const setItem = (key: string, value: string): Promise<void> => {
  return new Promise((resolve) => {
    localStorage.setItem(key, value);
    resolve();
  });
};

export const removeItem = (key: string): Promise<void> => {
  return new Promise((resolve) => {
    localStorage.removeItem(key);
    resolve();
  });
};
// export async function downloadFile(data) {
//   const headers = Object.assign(
//     {'content-type': 'application/json'},
//     data.token ? {'Authorization': `Bearer ${data.token}`} : {}
//   );
//   return request(resolveUrl(data.url, data.base), {
//     method: 'GET',
//     headers,
//     responsrType: 'blob'
//   });
// };
export const downloadFile = (data: downloadFileProps) => {
  const headers = Object.assign(
    {'content-type': 'application/json'},
    data.token ? {'Authorization': `Bearer ${data.token}`} : {}
  );
  return fetch(resolveUrl(data.url, data.base), {
    method: 'GET',
    headers,
  }).then((res) => {
    res.blob().then((blob) => {
      // saveBlob(blob, 'abc.csv');
      const filename = data.fileName + '.csv';
      // TypeScript 类型修复：IE 兼容代码
      const nav = window.navigator as any;
      if (nav.msSaveOrOpenBlob) {
        nav.msSaveBlob(blob, filename);
      } else {
        const anchor = document.createElement('a');
        const body = document.querySelector('body');
        anchor.href = window.URL.createObjectURL(blob);
        anchor.download = filename;
        anchor.style.display = 'none';
        body.appendChild(anchor);
        anchor.click();
        body.removeChild(anchor);
        window.URL.revokeObjectURL(anchor.href);
      }
    });
  });
};

export const downloadPDFFile = (data) => {
  const headers = Object.assign(
    {'content-type': 'application/json'},
    data.token ? {'Authorization': `Bearer ${data.token}`} : {}
  );
  return fetch(resolveUrl(data.url, data.base), {
    method: 'GET',
    headers,
  }).then((res) => {
    res.blob().then((blob) => {
      // saveBlob(blob, 'abc.csv');
      const filename = data.fileName + '.pdf';
      const nav = window.navigator as any;
      if (nav.msSaveOrOpenBlob) {
        nav.msSaveBlob(blob, filename);
      } else {
        const anchor = document.createElement('a');
        const body = document.querySelector('body');
        anchor.href = window.URL.createObjectURL(blob);
        anchor.download = filename;
        anchor.style.display = 'none';
        body.appendChild(anchor);
        anchor.click();
        body.removeChild(anchor);
        window.URL.revokeObjectURL(anchor.href);
      }
    });
  });
};

interface downloadFileProps {
  url: string;
  base?: string;
  token: string;
  fileName: string;
  extends?: string;
  body?: any;
}
export const downloadFileByPost = (data: downloadFileProps) => {
  const headers = Object.assign(
    {'content-type': 'application/json'},
    data.token ? {'Authorization': `Bearer ${data.token}`} : {}
  );
  return fetch(resolveUrl(data.url, data.base), {
    method: 'POST',
    headers,
    body: JSON.stringify(data.body)
  }).then((res) => {
    res.blob().then((blob) => {
      // saveBlob(blob, 'abc.csv');
      const filename = data.fileName + (data.extends?('.'+data.extends):'');
      const nav = window.navigator as any;
      if (nav.msSaveOrOpenBlob) {
        nav.msSaveBlob(blob, filename);
      } else {
        const anchor = document.createElement('a');
        const body = document.querySelector('body');
        anchor.href = window.URL.createObjectURL(blob);
        anchor.download = filename;
        anchor.style.display = 'none';
        body.appendChild(anchor);
        anchor.click();
        body.removeChild(anchor);
        window.URL.revokeObjectURL(anchor.href);
      }
    });
  });
};

export const downloadPDFByPost = (data) => {
  const headers = Object.assign(
    {'content-type': 'application/json'},
    data.token ? {'Authorization': `Bearer ${data.token}`} : {}
  );
  return fetch(resolveUrl(data.url, data.base), {
    method: 'POST',
    headers,
    body: JSON.stringify(data.body)
  }).then((res) => {
    res.blob().then((blob) => {
      // saveBlob(blob, 'abc.csv');
      const filename = data.fileName + '.pdf';
      const nav = window.navigator as any;
      if (nav.msSaveOrOpenBlob) {
        nav.msSaveBlob(blob, filename);
      } else {
        const anchor = document.createElement('a');
        const body = document.querySelector('body');
        anchor.href = window.URL.createObjectURL(blob);
        anchor.download = filename;
        anchor.style.display = 'none';
        body.appendChild(anchor);
        anchor.click();
        body.removeChild(anchor);
        window.URL.revokeObjectURL(anchor.href);
      }
    });
  });
};

interface FetchProps {
  base?: string;
  url: string;
  token?: string;
  acceptLanguage?: string;
}
export function getJSON<Result = unknown>(
  data: FetchProps & { query?: Record<string, unknown> }
): Promise<Result> {
  const headers = Object.assign(
    {'content-type': 'application/json'},
    data.token ? {'Authorization': `Bearer ${data.token}`} : {}
  );

  return fetch(resolveUrl(data.url, data.base), {
    method: 'get',
    headers
  }).then((res) => {
    if (res.ok) {
      if (res.status === 204) {
        return;
      }
      if (typeof res.text === 'function') {
        return res.text().then((text) => text ? JSON.parse(text) : undefined);
      }
      return res.json();
    }
    if (res.status >= 400 && res.status < 500) {
      return res.json().then((message) => {
        throw message;
      });
    }
    throw new Error(res.statusText);
  });
}

export const putJSON = (data) => {
  const headers = Object.assign(
    {'content-type': 'application/json'},
    data.token ? {'Authorization': `Bearer ${data.token}`} : {}
  );

  return fetch(resolveUrl(data.url, data.base), {
    method: 'put',
    headers,
    body: JSON.stringify(data.body)
  }).then((res) => {
    if (res.ok) {
      if (res.status === 204) {
        return;
      }
      return res.json();
    }
    if (res.status >= 400 && res.status < 500) {
      return res.json().then((message) => {
        throw message;
      });
    }
    throw new Error(res.statusText);
  });
};

export function postJSON<Result = unknown, Body = unknown>(
  data: FetchProps & { body?: Body }
): Promise<Result> {
  const headers = Object.assign(
    {'content-type': 'application/json'},
    data.token ? {'Authorization': `Bearer ${data.token}`} : {}
  );
  return fetch(resolveUrl(data.url, data.base), {
    method: 'post',
    headers,
    body: JSON.stringify(data.body)
  }).then((res) => {
    if (res.ok) {
      if (res.status === 204) {
        return;
      }
      return res.json();
    }
    if (res.status >= 400 && res.status < 500) {
      return res.json().then((message) => {
        throw message;
      });
    }
    throw new Error(res.statusText);
  });
}

export function deleteJSON<Result = unknown, Body = unknown>(
  data: FetchProps & { body?: Body }
): Promise<Result> {
  const headers = Object.assign(
    {'content-type': 'application/json'},
    data.token ? {'Authorization': `Bearer ${data.token}`} : {}
  );

  return fetch(resolveUrl(data.url, data.base), {
    method: 'delete',
    headers,
    body: JSON.stringify(data.body)
  }).then((res) => {
    if (res.ok) {
      if (res.status === 204) {
        return;
      }
      return res.json();
    }
    if (res.status >= 400 && res.status < 500) {
      return res.json().then((message) => {
        throw message;
      });
    }
    throw new Error(res.statusText);
  });
}

export const upload = (data) => {
  const headers = data.token ?
    {'Authorization': `Bearer ${data.token}`}
    : {};

  const body = new FormData();
  body.append('tenantId', data.tenantId);
  body.append('file', data.file);

  return fetch(resolveUrl(data.url, data.base), {
    method: 'post',
    headers,
    body
  }).then((res) => {
    if (res.ok) {
      return res.json();
    }
    if (res.status >= 400 && res.status < 500) {
      return res.json().then((message) => {
        throw message;
      });
    }
    throw new Error(res.statusText);
  });
};
const getCountWithUnit = (count, backunit) => {
  let unit = 'B'; //不足1kb，以b/s来计算速度
  // kb/s
  if (count / 1024 > 1) { //当大小超过1024b(即1kb时)，以kb/s来计算速度
    unit = 'KB';
    count = count / 1024;
  }
  // mb/s
  if (count / 1024 > 1) { //当大小超过1024Kb(即1mb时)，以mb/s来计算速度
    unit = 'MB';
    count = count / 1024;
  }
  if (count / 1024 > 1) { //当大小超过1024Kb(即1mb时)，以mb/s来计算速度
    unit = 'GB';
    count = count / 1024;
  }
  return  count.toFixed(2)+unit+backunit;
};
export const axiosUpload = (data, onProgress) => {
  const headers = data.token ?
    {'Authorization': `Bearer ${data.token}`}
    : {};
  const body = new FormData();
  if (data.tenantId)
    body.append('tenantId', data.tenantId);
  body.append('file', data.file);

  let stime = new Date().getTime();
  let sloaded = 0;
  return axios({
    url:resolveUrl(data.url, data.base),
    method: 'post',
    headers,
    signal: data?.controller?.signal || null,
    data:body,
    onUploadProgress: ({total, loaded}) => {
      const endTime = new Date().getTime();
      const dTime = (endTime - stime) / 1000; //毫秒换算成秒
      const dloaded = loaded - sloaded;
      const speed = dloaded / dTime;
      stime = new Date().getTime();
      sloaded = loaded;

      if (onProgress)
        onProgress(data.file, loaded/total, getCountWithUnit(speed, '/s'), getCountWithUnit(total, ''));
    }
  }).then((res) => {
    if (res.status==200) {
      return res.data;
    }
    if (res.status >= 400 && res.status < 500) {
      return res.data;
    }
  }).catch((err) => {
    console.log('err', err);
  });
};
export const axiosUploadLimited = (data, onProgress, uploadSpeedLimit) => {
  const headers = data.token ? { 'Authorization': `Bearer ${data.token}` } : {};

  const chunkSize = 1024 * 1024; // 每个数据块的大小（1MB）
  const fileSize = data.file.size;
  const totalChunks = Math.ceil(fileSize / chunkSize);
  let currentChunk = 0;
  const uploadNextChunk = () => {
    const start = currentChunk * chunkSize;
    const end = Math.min(start + chunkSize, fileSize);
    const chunk = data.file.slice(start, end);

    const formData = new FormData();
    formData.append('tenantId', data.tenantId);
    formData.append('file', chunk);

    axios({
      url: resolveUrl(data.url, data.base),
      method: 'post',
      headers,
      data: formData,
    }).then(() => {
      currentChunk++;

      // 计算上传进度
      const progress = currentChunk / totalChunks;
      if (onProgress) {
        onProgress(data.file, progress);
      }

      // 继续上传下一个数据块
      if (currentChunk < totalChunks) {
        setTimeout(uploadNextChunk, calculateUploadDelay(chunk.size, uploadSpeedLimit));
      }
    });
  };

  const calculateUploadDelay = (chunkSize, speedLimit) => {
    const chunkTime = (chunkSize / speedLimit) * 1000; // 计算上传时间（单位：毫秒）
    return Math.max(chunkTime, 0); // 最小延迟为 0
  };

  // 开始上传第一个数据块
  uploadNextChunk();
};

export const getBlob = (data) => {
  const headers = Object.assign(
    // {'content-type': 'application/json'},
    data.token ? {'Authorization': `Bearer ${data.token}`} : {}
  );

  return fetch(resolveUrl(data.url, data.base), {
    method: 'get',
    headers
  }).then((res) => {
    if (res.ok) {
      return res.blob();
    }
    if (res.status >= 400 && res.status < 500) {
      return res.json().then((message) => {
        throw message;
      });
    }
    throw new Error(res.statusText);
  });
};
